<!DOCTYPE html>
<html>
<head>
  <style>
    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
    }

    body {
      background: transparent;
    }
  </style>
</head>
<body>

  <h1>Informações sobre as previsões de agitação marítima</h1>

  <p align="justify">
    As previsões provêm da implementação do modelo numérico de previsão de ondas SWAN para a região da Ria de Aveiro.
    Este modelo operacional tem uma resolução horizontal de 50 m e é atualizado diariamente pela Hidromod.
  <p align="justify">
  <p>As previsões de agitação marítimas são fornecidas para o ponto de referência a 0.45 milhas da entrada da barra de Aveiro (40&#176;38,21'N;8&#176;46,27'W).</p>
  <p></p>
  <p><b>Unidades das variáveis:</b></p>
  <UL>
    <LI>Altura significativa: metros [m];</LI>
    <LI>Direção média da ondulação: graus [°];</LI>
    <LI>Período médio: segundos [s];</LI>
    <LI>Período de pico: segundos [s].</LI>
  </UL>
</body>
</html>
